import Cookies from 'js-cookie'
export const TokenKey = 'X-Token'

export function isLogin() {
  return !!localStorage.getItem(TokenKey)
}

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token: string) {
  localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
}

export function getUserInfo() {
  const userInfo: any = Cookies.get('userInfo')
  return userInfo ? JSON.parse(userInfo) : {}
}

export function setUserInfo(data: any) {
  Cookies.set('userInfo', JSON.stringify(data))
}
